module.exports = __webpack_public_path__ + "media/images/for-staff-bg-00acb0a1070e400336e5bbfd293951da.png";